import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router';
import styled from 'styled-components';
import { Checkbox } from 'components/Form/Checkbox';
import Icon from 'components/Icon';
import { CheckInModal } from 'components/Modal';
import Pagination from 'components/Pagination';
import { getDriverName } from 'components/Registrations/RegistrationsDesktop';
import { UpdateRegistration } from 'components/Registrations/UpdateRegistration';
import Spacer from 'components/Spacer';
import Text from 'components/Text';
import useTheme from 'hooks/useTheme';
import {
  useCheckinRegistration,
  useGetEventRegistrations,
  useUnCheckRegistration,
} from './gql';

const ParticipantList = styled.div`
  background-color: #fff;
  border-radius: 5px;
  height: 100%;
  width: calc(100% - 20px);
  margin: 0 10px 0 10px;
  padding: 10px;
  box-sizing: border-box;
`;

const ParticipantRow = styled.div`
  cursor: pointer;
  display: flex;
  margin: 15px 0;
  background-color: ${(props) =>
    props.highlighted ? props.theme.colors.primaryOpacity(0.1) : 'none'};
  color: ${(props) =>
    props.highlighted ? props.theme.colors.text.gray : 'inherit'};
`;

const ItemRow = styled.div`
  display: flex;
  margin: 15px 0 15px 15px;
  width: 100%;
  justify-content: space-between;
`;

const Wrapper = styled.div`
  @media (max-width: 768px) {
    ${(props) =>
      props.currentTransaction
        ? `  position: fixed;
    width: 100%;
    overflow: hidden;`
        : ''};
  }
`;

export const RegistrationsTransactionsListMobile = (props) => {
  const { currentPage, queryString, ticket_id, division } = props;
  const theme = useTheme();
  const { data } = useGetEventRegistrations(ticket_id, division);
  const [currentTransaction, setCurrentTransaction] = useState(null);
  const [shouldDisplayUpdateModal, setShouldDisplayUpdateModal] =
    useState(false);
  const [shouldDisplayCheckInModal, setShouldDisplayCheckInModal] =
    useState(false);
  const [unCheck, setUncheck] = useState(false);

  const history = useHistory();
  const { pathname } = useLocation();
  const userType = pathname?.split('/').includes('admin-track')
    ? 'track'
    : pathname?.split('/').includes('admin-employee')
    ? 'employee'
    : 'admin';

  const checkinRegistration = useCheckinRegistration();
  const unCheckRegistration = useUnCheckRegistration();

  if (!data?.getEvent && !data?.getEventRegistrations) return null;

  const transactions = data.getEventRegistrations.results ?? [];

  async function onConfirmCheckIn() {
    const { id } = currentTransaction;
    return unCheck
      ? await unCheckRegistration(id)
      : await checkinRegistration(id);
  }

  return (
    <>
      <Wrapper currentTransaction={currentTransaction}>
        <ParticipantList>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Text type="heading">
              Registrations (
              {data.loading ? 0 : data.getEventRegistrations.count})
            </Text>
          </div>
          <Spacer size={10} />
          {!transactions.length ? (
            <p
              style={{
                color: '#000',
                fontSize: 20,
                fontFamily: 'Barlow Condensed',
                fontWeight: 600,
                padding: '20px 0',
              }}
            >
              {queryString && queryString.length
                ? 'There are no registrations that match your search.'
                : 'The event does not have any Registrations yet'}
            </p>
          ) : null}
          {transactions.map((transaction, index) => {
            const driverName = getDriverName(
              transaction.data,
              transaction.user
            );
            const { id, is_checked, pass_id, is_signed } = transaction;

            return (
              <ParticipantRow key={index} highlighted={!is_signed}>
                <Checkbox
                  key={id}
                  name="check_in"
                  aria-checked={!!is_checked}
                  role="checkbox"
                  checked={!!is_checked}
                  zIndex={10}
                  inversed
                  onChange={() => {
                    setCurrentTransaction(transaction);
                    setUncheck(!!is_checked);
                    setShouldDisplayCheckInModal(true);
                  }}
                  size={[36, 20, 3]}
                />
                <ItemRow
                  onClick={() => {
                    history.push(
                      userType === 'admin'
                        ? `/admin/registrationDetail/registration/${pass_id}`
                        : `/admin-${userType}/registrationDetail/registration/${pass_id}`
                    );
                  }}
                  onKeyUp={() => {
                    history.push(
                      userType === 'admin'
                        ? `/admin/registrationDetail/registration/${pass_id}`
                        : `/admin-${userType}/registrationDetail/registration/${pass_id}`
                    );
                  }}
                  role="button"
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      padding: '10px 0',
                    }}
                  >
                    <Text
                      inlineStyle={{
                        fontWeight: '500',
                        fontSize: 20,
                        marginLeft: 20,
                      }}
                      tabIndex={0}
                    >
                      {driverName && driverName.toUpperCase()}
                    </Text>
                  </div>
                  <div style={{ transform: 'rotate(-90deg)' }}>
                    <Icon
                      icon="chevron"
                      color={theme.colors.primary}
                      size={22}
                    />
                  </div>
                </ItemRow>
              </ParticipantRow>
            );
          })}
        </ParticipantList>
        <Spacer size={10} />
        <div
          style={{ backgroundColor: '#00001F', margin: 10, borderRadius: 5 }}
        >
          <Pagination
            count={data.loading ? 0 : data.getEventRegistrations.count}
            perPage={15}
            currentPage={currentPage || 1}
            color={'#fff'}
          />
        </div>
      </Wrapper>
      <UpdateRegistration
        currentTransaction={currentTransaction}
        close={() => {
          setShouldDisplayUpdateModal(false);
          setCurrentTransaction(null);
        }}
        isVisible={shouldDisplayUpdateModal}
      />
      <CheckInModal
        itemType="guest"
        isVisible={shouldDisplayCheckInModal}
        onConfirm={onConfirmCheckIn}
        setIsVisible={setShouldDisplayCheckInModal}
        unCheck={unCheck}
      />
    </>
  );
};
